import {Attribute} from './attribute.model';
import {Entity} from './entity.model';
import {Program} from './program.model';

export class RefData {
  programs: Program[];
  tests: Entity[];
  specialities: Attribute[];
  tags: Entity[];
  reviewers: Attribute[];
  statuses: Attribute[];
}
